import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { BrowserAuthOptions, BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { AppConfig } from '../app/app-services/config/config.app';

export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALInstanceFactory(appConfig: AppConfig): IPublicClientApplication {
  const authOptions: BrowserAuthOptions = {
    clientId: appConfig.authentication.clientId,
    authority: appConfig.authentication.authority,
    navigateToLoginRequestUrl: appConfig.authentication.navigateToLoginRequestUrl,
    knownAuthorities: appConfig.authentication.knownAuthorities,
    redirectUri: appConfig.authentication.redirectUri,
    postLogoutRedirectUri: appConfig.authentication.postLogoutRedirectUri
  }
  return new PublicClientApplication({
    auth: authOptions,
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(appConfig: AppConfig): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  // protectedResourceMap.set("https://graph.microsoft.com/v1.0/me", ["user.read"]);
  // protectedResourceMap.set("https://aauto-functions.azurewebsites.net", ["https://aautologin.onmicrosoft.com/79c56f97-2e86-4eb0-a452-b56452eb07ee/token.write"]);
  // protectedResourceMap.set("http://localhost:7082/", ["https://aautologin.onmicrosoft.com/79c56f97-2e86-4eb0-a452-b56452eb07ee/organization.readwrite"]);  
  appConfig.authentication.protectedResources.forEach(resource => {
    protectedResourceMap.set(resource.url, resource.scope);
  });

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      // scopes: ['user.read']
    },
    loginFailedRoute: '/login-failed' // Changed from landing page to prevent redirect loop
  };
}
